@if (tenant?.enabled_features?.new_onboarding) {
  @if (showSSOButton) {
    <div
      [ngStyle]="{ height: '100%' }"
      class="u-width-100"
      fxLayout="column"
      fxLayoutAlign="space-between center"
    >
      <div class="u-width-100">
        <app-sso-signin
          [isSignupPage]="true"
          [ssoErrorMessage]="ssoErrorMessage"
          [ssoErrorStatus]="+ssoErrorStatus"
          [ssoSignInParams]="ssoSignInParams"
          [tenant]="tenant"
          (authWithEmailClicked)="signUpWithEmailHandler()"
          class="u-display-block u-width-100"
        />
        <ng-container [ngTemplateOutlet]="loginLink" />
      </div>
      <p
        class="text-caption u-width-100 u-textAlign-center u-whiteSpace-noWrap"
        fxLayout="row wrap"
        fxLayoutAlign="center end"
      >
        @if (!tenant?.legal?.link) {
          <ng-container i18n="@@signUpView.tosPrivacyDisclaimer">
            By clicking Sign up above, you are agreeing to our
            <a
              class="color-blue u-marginLeft-2xsmall"
              href="https://www.tenthousandcoffees.com/terms-conditions"
            >
              Terms of Service
            </a>
            <div class="u-marginLeft-2xsmall">and</div>
            <a
              class="color-blue u-marginLeft-2xsmall"
              href="https://www.tenthousandcoffees.com/privacy-policy"
            >
              Privacy Policy</a
            >
          </ng-container>
        } @else {
          <ng-container i18n="@@signUpView.tosPrivacyLegalDisclaimer">
            By clicking sign up above, you are agreeing to our
            <a
              class="color-blue u-marginLeft-2xsmall"
              href="https://www.tenthousandcoffees.com/terms-conditions"
            >
              Terms of Service</a
            >,
            <a
              class="color-blue u-marginLeft-2xsmall"
              href="https://www.tenthousandcoffees.com/privacy-policy"
            >
              Privacy Policy</a
            >
            <div class="u-marginLeft-2xsmall">
              and {{ tenant.friendly_name | textToPossessive }}
              <a
                [href]="tenant.legal.link"
                class="color-blue"
                target="_blank"
                >{{ tenant.legal.title }}</a
              >
            </div>
            .
          </ng-container>
        }
      </p>
    </div>
  } @else {
    <div class="u-width-100" fxLayout="column" fxLayoutAlign="center center">
      <form
        [formGroup]="form"
        [ngStyle]="{ 'max-width': '500px' }"
        class="u-width-100"
        fxLayout="column"
        fxLayoutGap="24px"
        nz-form
        nzLayout="vertical"
      >
        <nz-form-item class="u-width-100">
          <nz-form-label
            class="u-marginBottom-0"
            i18n="@@global.firstName"
            nzRequired
          >
            First name
          </nz-form-label>
          <nz-form-control [nzErrorTip]="firstNameErrorTips">
            <input
              [ngStyle]="{ height: '40px' }"
              autocomplete="off"
              autofocus
              formControlName="first_name"
              nz-input
              required
            />
          </nz-form-control>
          <ng-template #firstNameErrorTips>
            @if (form.get('first_name').errors; as errors) {
              @if (errors?.minlength) {
                <div i18n="@@signupView.firstNameErrorTips.minlength">
                  Please enter a first name that is longer than one character
                </div>
              }
              @if (errors?.required) {
                <div i18n="@@signupView.firstNameErrorTips.required">
                  Please enter a valid first name
                </div>
              }
            }
          </ng-template>
        </nz-form-item>
        <nz-form-item class="u-marginBottom-8 u-width-100">
          <nz-form-label i18n="@@global.lastName" nzRequired
            >Last name</nz-form-label
          >
          <nz-form-control [nzErrorTip]="lastNameErrorTips">
            <input
              [ngStyle]="{ height: '40px' }"
              autocomplete="off"
              formControlName="last_name"
              nz-input
              required
            />
          </nz-form-control>
          <ng-template #lastNameErrorTips>
            @if (form.get('last_name').errors; as errors) {
              @if (errors?.minlength) {
                <div i18n="@@signupView.lastNameErrorTips.required">
                  Please enter a last name that is longer than one character
                </div>
              }
              @if (errors?.required) {
                <div i18n="@@signupView.lastNameErrorTips.required">
                  Please enter a valid last name
                </div>
              }
            }
          </ng-template>
        </nz-form-item>
        <nz-form-item
          class="u-marginBottom-8 mat-form-field-width-100 u-width-100"
        >
          <nz-form-label i18n="@@global.email" nzRequired>Email</nz-form-label>
          <nz-form-control [nzErrorTip]="emailErrorTip">
            <input
              [ngStyle]="{ height: '40px' }"
              autocomplete="off"
              formControlName="email"
              nz-input
              required
              type="email"
            />
          </nz-form-control>
          <ng-template #emailErrorTip>
            <div i18n="@@signupView.emailErrorTip">
              Please enter a valid email
            </div>
          </ng-template>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control
            [nzErrorTip]="policyErrorTips"
            fxLayout="column"
            fxLayoutAlign="center center"
          >
            <label [formControl]="policyAgreementControl" nz-checkbox>
              <p
                i18n="@@signupView.termsAndConditionsPrompt"
                class="text-caption color-grey-300"
              >
                I agree to the
                <a
                  class="color-blue"
                  href="https://www.tenthousandcoffees.com/terms-conditions"
                  >Terms of Service</a
                >,
                @if (!tenant.legal?.link) {
                  and
                }
                <a
                  class="color-blue"
                  href="https://www.tenthousandcoffees.com/privacy-policy"
                  >Privacy Policy</a
                >
                @if (!tenant?.legal?.link) {
                  .
                }
                @if (tenant?.legal?.link) {
                  and {{ tenant?.friendly_name | textToPossessive }}
                  <a
                    [href]="tenant?.legal?.link"
                    class="color-blue"
                    target="_blank"
                    >{{ tenant.legal?.title }}</a
                  >.
                }
              </p>
            </label>
          </nz-form-control>
          <ng-template #policyErrorTips>
            <div
              fxLayoutAlign="center center"
              i18n="@@signupView.policyAgreement"
            >
              You must agree to the Terms of Service and Privacy Policy to
              continue
            </div>
          </ng-template>
        </nz-form-item>
      </form>
      <div class="u-width-100">
        <div class="u-marginTop-medium">
          <ng-container [ngTemplateOutlet]="loginLink" />
        </div>
        <div
          [fxLayoutAlign]="
            tenantHasSSOEnabled ? 'space-between center' : 'end center'
          "
          class="u-width-100"
          fxLayout="row"
        >
          @if (tenantHasSSOEnabled) {
            <button
              (click)="backButtonHandler()"
              color="white"
              mat-stroked-button
            >
              <div fxLayoutAlign="center center" fxLayoutGap="8px">
                <span i18n="@@global.back">Back</span>
              </div>
            </button>
          }
          <form
            [formGroup]="form"
            (ngSubmit)="submitForm(form)"
            class="margin-top-24"
          >
            <button
              [disabled]="isLoading"
              color="primary"
              mat-flat-button
              type="submit"
            >
              <div fxLayoutAlign="center center" fxLayoutGap="8px">
                <span i18n="@@signupView.createAccountCta">Create Account</span>
                @if (isLoading) {
                  <i
                    class="u-marginLeft-8"
                    nz-icon
                    nzSpin
                    nzTheme="outline"
                    nzType="sync"
                  ></i>
                }
              </div>
            </button>
          </form>
        </div>
      </div>
    </div>
  }
  <ng-template #loginLink>
    <p
      [ngStyle]="{ 'font-size': showSSOButton ? '18px' : '' }"
      class="u-textAlign-center color-text-subdued text-body-lg"
      i18n="@@signUpView.loginPrompt"
    >
      Already have an account?
      <a
        [routerLink]="['/login']"
        class="color-blue c-button"
        queryParamsHandling="merge"
      >
        Log in
      </a>
    </p>
  </ng-template>
} @else {
  @if (showSSOButton) {
    <app-sso-signin
      [showPrivacyDisclaimer]="true"
      [ssoErrorMessage]="ssoErrorMessage"
      [ssoErrorStatus]="+ssoErrorStatus"
      [ssoSignInParams]="ssoSignInParams"
      [tenant]="tenant"
      class="u-display-block"
    ></app-sso-signin>
    @if (tenant.email_login_enabled) {
      <p
        i18n="@@signupView.joinWithEmailPrompt"
        class="color-grey-300 u-paddingTop-8"
      >
        Or,
        <button
          (click)="showSSOButton = false"
          class="c-button color-blue"
          type="button"
        >
          use a magic link via your email address</button
        >.
      </p>
    }
  } @else {
    <form
      [formGroup]="form"
      (ngSubmit)="submitForm(form)"
      class="margin-bottom-24"
    >
      <mat-form-field class="u-marginBottom-8 mat-form-field-width-100">
        <mat-label i18n="@@global.firstName">First name</mat-label>
        <input
          autocomplete="off"
          formControlName="first_name"
          matInput
          required
        />
      </mat-form-field>
      <mat-form-field class="u-marginBottom-8 mat-form-field-width-100">
        <mat-label i18n="@@global.lastName">Last name</mat-label>
        <input
          autocomplete="off"
          formControlName="last_name"
          matInput
          required
        />
      </mat-form-field>
      <mat-form-field class="u-marginBottom-8 mat-form-field-width-100">
        <mat-label i18n="@@global.email">Email</mat-label>
        <input
          autocomplete="off"
          formControlName="email"
          matInput
          required
          type="email"
        />
      </mat-form-field>
      <mat-checkbox
        [formControl]="policyAgreementControl"
        class="mat-checkbox--longText u-display-block u-marginBottom-16"
        disableRipple="true"
      >
        <p
          i18n="@@signupView.termsAndConditionsPrompt"
          class="text-caption color-grey-300"
        >
          I agree to the
          <a
            class="color-blue"
            href="https://www.tenthousandcoffees.com/terms-conditions"
            >Terms of Service</a
          >,
          @if (!tenant.legal?.link) {
            and
          }
          <a
            class="color-blue"
            href="https://www.tenthousandcoffees.com/privacy-policy"
            >Privacy Policy</a
          >
          @if (!tenant?.legal?.link) {
            .
          }
          @if (tenant?.legal?.link) {
            and {{ tenant?.friendly_name | textToPossessive }}
            <a
              [href]="tenant?.legal?.link"
              class="color-blue"
              target="_blank"
              >{{ tenant.legal?.title }}</a
            >.
          }
        </p>
      </mat-checkbox>
      @if (!!form.getError('server')) {
        <mat-error class="u-marginBottom-16">
          <span
            i18n="@@signupView.serverError"
            >{form.getError('server'), select,
              other {{{ form.getError('server') }}}

          }</span>
        </mat-error>
      }
      <div fxLayout="row" fxLayoutAlign="start center">
        <button
          [disabled]="
            isLoading || !form.valid || policyAgreementControl.invalid
          "
          color="primary"
          mat-raised-button
          type="submit"
        >
          <span i18n="@@signupView.joinCta">Join</span>
          @if (isLoading) {
            <i
              class="u-marginLeft-8"
              nz-icon
              nzSpin
              nzTheme="outline"
              nzType="sync"
            ></i>
          }
        </button>
      </div>
      @if (tenant?.integrations?.workos?.sso_signup_enabled) {
        <p
          i18n="@@signupView.joinWithSSOPrompt"
          class="color-grey-300 u-paddingTop-16"
        >
          Or,
          <button
            (click)="showSSOButton = true"
            class="c-button color-blue"
            type="button"
          >
            use your team's Single sign-on authentication</button
          >.
        </p>
      }
    </form>
  }
}
